<app-hero
	[title]="'hero.registration' | translate"
	imageDesktop="assets/hero/registration-hero-3840x400.jpg"
	imageMobile="assets/hero/registration-hero-768x180.jpg"
/>
<div class="container mt-4">
	<button
		(click)="goBack()"
		class="nav-btn left text-uppercase"
	>
		<mat-icon>chevron_left</mat-icon>{{ "vehicle.button.back" | translate }}
	</button>
	<form
		name="registrationForm"
		[formGroup]="registrationForm"
	>
		<section class="form">
			<div class="row">
				<div class="field col-sm-12">
					<h2
						style="border-top: unset"
						id="companyDataSection"
					>
						{{ "signup.businessName" | translate }}
					</h2>
				</div>
			</div>
			<div class="row">
				<div class="field col-sm-3">
					<app-formx-input
						[label]="'signup.businessName' | translate"
						[placeholder]="'signup.businessName' | translate"
						[errorText]="'registrationForm.error.mandatory' | translate"
						[control]="registrationForm.get('businessName')"
						[required]="true"
						[maxlength]="50"
						[showNotValidate]="showNotValidate"
					>
					</app-formx-input>
				</div>
				<div class="field col-sm-3">
					<app-formx-input
						[label]="'signup.country' | translate"
						[control]="registrationForm.get('country')"
						type="select"
						[options]="countryOptions"
						[required]="true"
						[showNotValidate]="showNotValidate"
						[errorText]="'registrationForm.error.mandatory' | translate"
						(change)="onChangeCountry($event.target.value)"
					>
					</app-formx-input>
				</div>
				<div class="field col-sm-3">
					<app-formx-input
						[label]="'signup.address' | translate"
						[placeholder]="'signup.address' | translate"
						[errorText]="'registrationForm.error.mandatory' | translate"
						[control]="registrationForm.get('address')"
						[required]="true"
						[maxlength]="100"
						[showNotValidate]="showNotValidate"
					>
					</app-formx-input>
				</div>
				<div class="field col-sm-3">
					<app-formx-input
						[label]="'signup.postalCode' | translate"
						[placeholder]="'signup.postalCode' | translate"
						[errorText]="(showFormatErrPostalCode ? 'registrationForm.error.format' : 'registrationForm.error.mandatory') | translate"
						[control]="registrationForm.get('postalCode')"
						[required]="['DE', 'IT', 'FR', 'ES', 'BE'].includes(selectedCountry)"
						[maxlength]="10"
						[showNotValidate]="showNotValidate"
					>
					</app-formx-input>
				</div>
			</div>
			<div class="row">
				<div class="field col-sm-3">
					<app-formx-input
						[label]="'signup.city' | translate"
						[placeholder]="'signup.city' | translate"
						[errorText]="'registrationForm.error.mandatory' | translate"
						[control]="registrationForm.get('city')"
						[required]="true"
						[maxlength]="50"
						[showNotValidate]="showNotValidate"
					>
					</app-formx-input>
				</div>
				@if (["IT", "BE", "DE", "EN", "ES", "FR", "NL", "PL"].includes(selectedCountry)) {
					<div class="field col-sm-3">
						<app-formx-input
							[label]="regionLabel | translate"
							[control]="registrationForm.get('region')"
							type="select"
							[options]="regionOptions"
							[required]="true"
							[showNotValidate]="showNotValidate"
							[errorText]="'registrationForm.error.mandatory' | translate"
							[attr.disabled]="!registrationForm.controls.country.valid ? '' : null"
						>
						</app-formx-input>
					</div>
				}
				<div class="field col-sm-3">
					<app-formx-input
						[label]="'signup.vatNumber' | translate"
						[placeholder]="'signup.vatNumber' | translate"
						[errorText]="(showFormatErrVat ? 'registrationForm.error.format' : 'registrationForm.error.mandatory') | translate"
						[control]="registrationForm.get('vatCode')"
						[required]="true"
						[maxlength]="50"
						[showNotValidate]="showNotValidate"
					>
					</app-formx-input>
				</div>
			</div>

			<div class="row">
				<div class="field col-sm-12">
					<h2 id="companyContactsSection">{{ "signup.businessContacts" | translate }}</h2>
				</div>
			</div>
			<div class="row">
				<!-- <div class="field col-sm-4">
					<label for="website">{{ "signup.website" | translate }}</label>
					<input
						id="website"
						type="text"
						name="website"
						[class.error-input]="(showNotValidate || registrationForm.controls.website.touched) && registrationForm.controls.website.invalid"
						formControlName="website"
						maxlength="16"
						[placeholder]="'signup.website' | translate"
					/>
				</div> -->
				<div class="field col-sm-3">
					<app-formx-input
						[label]="'signup.mobile' | translate"
						[placeholder]="'signup.mobile' | translate"
						[errorText]="'registrationForm.error.mandatory' | translate"
						[control]="registrationForm.get('mobile')"
						[required]="true"
						[maxlength]="50"
						[showNotValidate]="showNotValidate"
					>
					</app-formx-input>
				</div>
				@if (selectedCountry !== "DE") {
					<div class="field col-sm-3">
						<app-formx-input
							[label]="'signup.phone' | translate"
							[placeholder]="'signup.phone' | translate"
							[errorText]="'registrationForm.error.mandatory' | translate"
							[control]="registrationForm.get('phone')"
							[required]="false"
							[maxlength]="50"
							[showNotValidate]="showNotValidate"
						>
						</app-formx-input>
					</div>
				}
				@if (selectedCountry === "PL") {
					<div class="field col-sm-3">
						<app-formx-input
							[label]="'signup.regon' | translate"
							[placeholder]="'signup.regon' | translate"
							[errorText]="'registrationForm.error.mandatory' | translate"
							[control]="registrationForm.get('regon')"
							[required]="false"
							[maxlength]="50"
							[showNotValidate]="showNotValidate"
						>
						</app-formx-input>
					</div>
				}
				<div class="field col-sm-3">
					<app-formx-input
						[label]="'signup.email' | translate"
						[placeholder]="'signup.confEmail' | translate"
						[errorText]="(showFormatErrEmail ? 'registrationForm.error.format' : 'registrationForm.error.mandatory') | translate"
						[control]="registrationForm.get('email')"
						[required]="true"
						[maxlength]="100"
						[showNotValidate]="showNotValidate"
						(input)="confirmEmail($event, 'email')"
					>
					</app-formx-input>
				</div>
				<div class="field col-sm-3">
					<app-formx-input
						[label]="'signup.confEmail' | translate"
						[placeholder]="'signup.confEmail' | translate"
						[errorText]="
							showErrEmailNotMatch
								? ('registrationForm.error.confirmEmail' | translate)
								: showFormatErrConfEmail
									? ('registrationForm.error.format' | translate)
									: ('registrationForm.error.mandatory' | translate)
						"
						[control]="registrationForm.get('confEmail')"
						[required]="true"
						[maxlength]="100"
						[showNotValidate]="showNotValidate"
						(input)="confirmEmail($event, 'confirm')"
					>
					</app-formx-input>
				</div>
			</div>

			<div class="row">
				<div class="field col-sm-12">
					<h2 id="dealerSection">{{ "signup.dealerActivity" | translate }}</h2>
				</div>
			</div>
			<div class="row">
				<div class="field col-sm-3">
					<app-formx-input
						[label]="'signup.dealerActivityType' | translate"
						[control]="registrationForm.get('typeDealerActivity')"
						type="select"
						[options]="dealerActivityOptions"
						[required]="true"
						[showNotValidate]="showNotValidate"
						[errorText]="'registrationForm.error.mandatory' | translate"
					>
					</app-formx-input>
				</div>
				<div class="field col-sm-3">
					<app-formx-input
						[label]="'signup.carSold' | translate"
						[control]="registrationForm.get('carSold')"
						type="select"
						[options]="carSoldOptions"
						[required]="true"
						[showNotValidate]="showNotValidate"
						[errorText]="'registrationForm.error.mandatory' | translate"
					>
					</app-formx-input>
				</div>
				<div class="field col-sm-3">
					<app-formx-input
						[label]="'signup.buyingInterest' | translate"
						[control]="registrationForm.get('buyingInterest')"
						type="select"
						[options]="buyingInterestOptions"
						[required]="true"
						[showNotValidate]="showNotValidate"
						[errorText]="'registrationForm.error.mandatory' | translate"
					>
					</app-formx-input>
				</div>
			</div>
			<div class="row">
				<div
					class="field col-sm-12"
					id="internalReference"
				>
					<h2 id="intrnlRfrncSection">{{ "signup.internalReference" | translate }}</h2>
				</div>
			</div>

			<div class="row">
				<div class="field col-sm-3">
					<app-formx-input
						[label]="'signup.reference.surname' | translate"
						[placeholder]="'signup.reference.surname' | translate"
						[errorText]="'registrationForm.error.mandatory' | translate"
						[control]="registrationForm.get('referenceSurname')"
						[required]="true"
						[maxlength]="50"
						[showNotValidate]="showNotValidate"
					>
					</app-formx-input>
				</div>
				<div class="field col-sm-3">
					<app-formx-input
						[label]="'signup.reference.name' | translate"
						[placeholder]="'signup.reference.name' | translate"
						[errorText]="'registrationForm.error.mandatory' | translate"
						[control]="registrationForm.get('referenceName')"
						[required]="true"
						[maxlength]="50"
						[showNotValidate]="showNotValidate"
					>
					</app-formx-input>
				</div>
				@if (!["DE", "BE", "FR", "NL", "EN"].includes(selectedCountry)) {
					<div class="field col-sm-3">
						<app-formx-input
							[label]="'signup.reference.fiscalCode' | translate"
							[placeholder]="'signup.reference.fiscalCode' | translate"
							[control]="registrationForm.get('referenceFiscalCode')"
							[required]="selectedCountry === 'IT'"
							[maxlength]="20"
							[showNotValidate]="showNotValidate || showCFError"
							[errorText]="
								showCFError
									? ('registrationForm.error.fiscalCodeInvalid' | translate)
									: registrationForm.get('referenceFiscalCode').touched && registrationForm.get('referenceFiscalCode').invalid
										? showFormatErrFC
											? ('registrationForm.error.format' | translate)
											: selectedCountry === 'IT'
												? ('registrationForm.error.mandatory' | translate)
												: ''
										: ''
							"
							(change)="showCFError = false"
						>
						</app-formx-input>
					</div>
				}
				@if (selectedCountry !== "DE") {
					<div class="field col-sm-3">
						<app-formx-input
							[label]="'signup.reference.birthDate' | translate"
							[control]="registrationForm.get('referenceBirthDate')"
							type="datepicker"
							[bsConfig]="bsConfig"
							[required]="selectedCountry === 'IT'"
							[showNotValidate]="showNotValidate"
							[errorText]="(selectedCountry === 'IT' ? 'registrationForm.error.mandatory' : 'registrationForm.error.invalidDate') | translate"
						>
						</app-formx-input>
					</div>
				}
			</div>

			<div class="row">
				<div class="field col-sm-3">
					<app-formx-input
						[label]="'signup.reference.email' | translate"
						[placeholder]="'signup.reference.email' | translate"
						[control]="registrationForm.get('referenceEmail')"
						[required]="true"
						[maxlength]="50"
						[showNotValidate]="showNotValidate"
						[errorText]="
							registrationForm.get('referenceEmail').touched
								? showFormatErrRefEmail
									? ('registrationForm.error.format' | translate)
									: registrationForm.get('referenceEmail').invalid
										? ('registrationForm.error.mandatory' | translate)
										: ''
								: ''
						"
						type="text"
					>
					</app-formx-input>
				</div>
				<div class="field col-sm-3">
					<app-formx-input
						[label]="'signup.reference.fcaNote' | translate"
						[placeholder]="'signup.reference.fcaNote' | translate"
						[control]="registrationForm.get('referenceFCA')"
						[required]="true"
						[maxlength]="200"
						[showNotValidate]="showNotValidate"
						[errorText]="registrationForm.get('referenceFCA').touched && registrationForm.get('referenceFCA').invalid ? ('registrationForm.error.mandatory' | translate) : ''"
						type="text"
					>
					</app-formx-input>
				</div>
			</div>

			<div class="row">
				<div
					class="field col-sm-12"
					id="documents"
				>
					<h2 id="documents">{{ "vehicle.documentation" | translate }}</h2>
				</div>
			</div>
			@if (["IT", "DE"].includes(selectedCountry)) {
				<div
					class="row"
					id="docSection"
				>
					<div class="field col-sm-6">
						<label class="text-center">{{ "signup.uploadVisura" | translate }}*</label>
						@if (selectedCountry === "IT") {
							<label
								class="text-center"
								style="color: red; height: unset !important"
							>
								{{ "signup.uploadVisuraWarn" | translate }}
							</label>
						}
						<div
							class="uploadfilecontainer"
							(click)="fileInputSmallLogo.click()"
							appDragDrop
							(onFileDropped)="uploadVisura($event)"
							[class.input-error]="showErrorUpVisura && registrationForm.controls.visura.invalid"
						>
							<input
								hidden
								type="file"
								#fileInputSmallLogo
								(change)="uploadVisura($event.target.files)"
								(click)="onFileChange('visura')"
								accept="application/pdf"
							/>
							<input
								hidden
								type="text"
								formControlName="visura"
							/>
						</div>
						@if (visuraCamerale) {
							<div class="files-list my-3 mx-auto">
								<p>{{ visuraCamerale?.name }}</p>
								<button
									class="delete-file"
									(click)="deleteAttachmentVisura()"
								>
									<img
										class="iconInputFile"
										[src]="wcmService.trashCircleUrl"
									/>
								</button>
							</div>
						}
					</div>
					@if (selectedCountry !== "DE") {
						<div class="field col-sm-6">
							<label class="text-center">{{ "signup.uploadDoc" | translate }}*</label>
							@if (selectedCountry === "IT") {
								<label
									class="text-center"
									style="color: red; height: unset !important"
								></label>
							}
							<div
								class="uploadfilecontainer"
								(click)="fileInputLargeLogo.click()"
								appDragDrop
								(onFileDropped)="uploadDoc($event)"
								[class.input-error]="showErrorUpDoc && registrationForm.controls.doc.invalid"
							>
								<input
									hidden
									multiple
									type="file"
									#fileInputLargeLogo
									(change)="uploadDoc($event.target.files)"
									(click)="onFileChange('doc')"
									accept="image/jpeg,image/png,application/pdf,image/x-eps"
								/>
								<input
									hidden
									type="text"
									formControlName="doc"
								/>
							</div>
							@if (docLegalRefernce) {
								<div class="files-list my-3 mx-auto">
									<p>{{ docLegalRefernce?.name }}</p>
									<button
										class="delete-file"
										(click)="deleteAttachmentDoc()"
									>
										<img
											class="iconInputFile"
											[src]="wcmService.trashCircleUrl"
										/>
									</button>
								</div>
							}
							@if (docLegalRefernce2) {
								<div class="files-list my-3 mx-auto">
									<p>{{ docLegalRefernce2?.name }}</p>
									<button
										class="delete-file"
										(click)="deleteAttachmentDoc2()"
									>
										<img
											class="iconInputFile"
											[src]="wcmService.trashCircleUrl"
										/>
									</button>
								</div>
							}
						</div>
					}
				</div>
			}

			<div class="col-sm-12">
				<div class="info-item d-block">
					<p
						dir="ltr"
						style="white-space: pre-line"
					>
						<span style="font-size: 14px">{{ "consenso-reserved.p1" | translate }}</span>
					</p>
				</div>
			</div>

			<div class="consent-row">
				@if (localizedCountry !== "FR") {
					<div class="col-sm-12 d-flex justify-content-start">
						<input
							type="checkbox"
							[class.error-input]="(showNotValidate || registrationForm.controls.checkCCA.dirty) && registrationForm.controls.checkCCA.invalid"
							formControlName="checkCCA"
						/>
						<div class="info-item ms-2">
							<span>{{ "consensi.visuraCamerale" | translate }}</span>
						</div>
					</div>
				}
			</div>

			@if (["IT", "PT"].includes(selectedCountry)) {
				<div class="consent-row">
					<div class="col-sm-12 d-flex justify-content-start">
						<input
							type="checkbox"
							[class.error-input]="(showNotValidate || registrationForm.controls.checkTec.dirty) && registrationForm.controls.checkTec.invalid"
							formControlName="checkTec"
						/>
						<div class="info-item ms-2">
							<span>
								{{ "consensi.tec" | translate }}
								<u
									class="cursor-pointer"
									(click)="openTec()"
								>
									{{ "consensi.tecPopup" | translate }}
								</u>
							</span>
						</div>
					</div>
				</div>
			}

			<div class="row">
				<div class="field col-sm-12">
					<h2 id="consentsSection">{{ "signup.consents" | translate }}</h2>
				</div>
			</div>

			@if (selectedCountry === "IT") {
				<div class="consent-row">
					<div class="col-sm-12 d-flex justify-content-start">
						<input
							type="checkbox"
							[class.error-input]="(showNotValidate || registrationForm.controls.checkDati.dirty) && registrationForm.controls.checkDati.invalid"
							formControlName="checkDati"
						/>
						<div class="info-item d-block ms-3">
							<span>{{ "consensi.informativa" | translate }} </span>
							<span>
								<u
									class="cursor-pointer"
									(click)="openInformativa()"
								>
									{{ "consensi.informativaPopup" | translate }}
								</u>
							</span>
						</div>
					</div>
				</div>
			}

			<div class="row">
				<div class="info-item mb-4">
					<span>{{ "consensi.privacy" | translate }}</span>
				</div>
			</div>

			<div class="consent-row">
				<input
					type="checkbox"
					formControlName="checkConsents1"
					id="consent1"
				/>
				<div class="info-item">
					<div class="title">{{ "consenso-1.p1" | translate }}</div>
					<span>{{ "consenso-1.p2" | translate }}</span>
				</div>
			</div>

			@if (!["AT", "DE"].includes(countrySelected)) {
				<div class="consent-row">
					<input
						type="checkbox"
						formControlName="checkConsents2"
						id="consent2"
					/>
					<div class="info-item">
						<div class="title">{{ "consenso-2.p1" | translate }}</div>
						<span>{{ "consenso-2.p2" | translate }}</span>
					</div>
				</div>
			}

			<div class="consent-row">
				<input
					type="checkbox"
					formControlName="checkConsents3"
					id="consent3"
				/>
				<div class="info-item">
					<div class="title">{{ "consenso-3.p1" | translate }}</div>
					<span>{{ "consenso-3.p2" | translate }}</span>
				</div>
			</div>

			<div class="row">
				<div class="d-flex justify-content-end mb-5">
					<a
						(click)="onSubmit()"
						class="btn btn-blue text-uppercase mobile-full-width"
					>
						{{ "signup.signup" | translate }}
					</a>
				</div>
			</div>
		</section>
	</form>
</div>